import React, {useEffect, useRef, useState} from 'react';
import {initializeUser} from "../../services/user";
//
export const NavBar = () => {
    const [navBarHTML, setNavBarHTML] = useState(null);
    const divRef = useRef(null)

    useEffect(() => {
        fetch('/auth-api/nav-bar', {credentials: "include"})
            .then(response => response.json())
            .then(({auth, navBar}) => {
                setNavBarHTML(navBar);
                initializeUser(auth, navBar);

            }).catch( err => console.error(err));

    }, []);

    useEffect(() => {
        if ( ! divRef.current || ! navBarHTML ) return;
        const slotHtml = document.createRange().createContextualFragment(navBarHTML);
        divRef.current.innerHTML = ''; // Clear the container
        divRef.current.appendChild(slotHtml); // Append the new content

    }, [navBarHTML]);

    return <div ref={divRef} />
}
